import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/ingusion-formula";

export const saveIngusionFormula = ingusionFormula => axios.post(API_PATH + "/save", ingusionFormula);

export const getIngusionFormulaById = ingusionFormulaId => axios.get(API_PATH + "/get-by-id/" + ingusionFormulaId);

export const pagingIngusionFormula = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const deleteIngusionFormula = ingusionFormulaId => axios.delete(API_PATH + "/mark-delete/" + ingusionFormulaId);

export const getAllIngusionFormula = () => axios.get(API_PATH + "/get-all");

export const findListIngusionFormula = (searchObject) => axios.post(API_PATH + "/find-list-ingusion-formula", searchObject);
